module.exports = __webpack_public_path__ + "static/seal-9fbb4646f4d8a7fdc852cd537672eb96.png";